import { type FC } from 'react';
import { Modal } from '@g2u/ui-kit';
import { Table } from 'antd';
import { TablePaginationConfig, type ColumnsType } from 'antd/es/table';
import { Link } from 'react-router';

import { useSubscriptionJobs } from 'helpers/hooks/useSubscriptionJobs';
import { JOB_TYPE_LABELS, SubscriptionJob } from 'types';

const columns: ColumnsType<SubscriptionJob> = [
  {
    key: 'id',
    title: 'Job ID',
    render: (_: unknown, record: SubscriptionJob) => <Link to={`/job/edit/${record.ID}`}>{record.ID}</Link>,
  },
  {
    key: 'appointment',
    title: 'Appointment',
    dataIndex: 'appointment',
  },
  {
    key: 'jobType',
    title: 'Job Type',
    render: (_: unknown, record: SubscriptionJob) => JOB_TYPE_LABELS[record.job_type],
  },
  {
    key: 'hours',
    title: 'Hours',
    // Numeric DB columns can arrive as strings from the API; coerce before toFixed to avoid a crash.
    render: (_: unknown, record: SubscriptionJob) => Number(record.labour_hours_total).toFixed(1),
  },
];

type Props = {
  isOpen: boolean;
  subscriptionId?: number;
  onCancel: () => void;
};

export const JobLogsModal: FC<Props> = ({ isOpen, subscriptionId, onCancel }) => {
  const { jobs, paginationMetadata, isLoading } = useSubscriptionJobs(subscriptionId, isOpen);

  const pagination: TablePaginationConfig = {
    total: paginationMetadata.total,
    current: paginationMetadata.current_page,
    pageSize: paginationMetadata.pageSize,
    onChange: paginationMetadata.onChange,
    showSizeChanger: false,
    hideOnSinglePage: true,
  };

  return (
    <Modal.$ open={isOpen} title="Job Logs" onCancel={onCancel} footer={null} wide dataTestId="job-logs-modal">
      <Table rowKey="ID" columns={columns} dataSource={jobs} loading={isLoading} pagination={pagination} />
    </Modal.$>
  );
};
